function CompanyInfo() {
  return (
    <>
      <div
        className="container"
        style={{ fontSize: 20, fontFamily: "Times New Roman" }}
      >
        <h1>About Us</h1>
        Icom Inc. (アイコム株式会社, Aikomu Kabushiki-gaisha) is a Japanese[2]
        manufacturer of radio transmitting and receiving equipment,[3] founded
        in 1954 by Tokuzo Inoue with the company's original name being
        "Inoue".[4] Its products now include equipment for radio amateurs,
        pilots, maritime applications, land mobile professional applications and
        radio scanner enthusiasts. Its headquarters are in Osaka, Japan,[4] with
        branch offices in the United States (in Kirkland, Washington), Canada
        (in Delta, British Columbia), Australia (Melbourne, Victoria), New
        Zealand (Auckland), the United Kingdom (Kent, England), France
        (Toulouse), Germany (Bad Soden), Spain (Barcelona) and the People's
        Republic of China (Beijing).
      </div>
    </>
  );
}

export default CompanyInfo;
